import { App } from 'vue';
import ModalOverlay from '@/project/modals/ModalOverlay.vue';
import ResponsiveIconWrap from '@/project/shared/ResponsiveIconWrap.vue';
import ProductTile from '@/project/product/product-tile/ProductTile.vue';
import ReadMore from '@/core/ui-components/ReadMore.vue';

export default function config(app: App): void {
    // Global components that we want to use on multiple pages
    app.component('ResponsiveIconWrap', ResponsiveIconWrap);
    app.component('ModalOverlay', ModalOverlay);

    // Due to recursiveness
    app.component('ProductTile', ProductTile);
    app.component('ReadMore', ReadMore);
}
